import script from "./payment.vue?vue&type=script&setup=true&lang=js"
export * from "./payment.vue?vue&type=script&setup=true&lang=js"

import "./payment.vue?vue&type=style&index=0&id=47ec8fca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ec8fca"]])

export default __exports__